/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M8.99997 16H15"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M22 14V11.845C22 10.433 22 9.72701 21.8204 9.07517C21.6613 8.49771 21.3998 7.95353 21.0483 7.46857C20.6514 6.92115 20.1001 6.48011 18.9976 5.59805L16.9976 3.99805C15.214 2.57118 14.3222 1.85774 13.3332 1.58413C12.4608 1.34279 11.5392 1.34279 10.6668 1.58413C9.67783 1.85774 8.78603 2.57118 7.00244 3.99805L5.00244 5.59805C3.89986 6.48011 3.34857 6.92115 2.95174 7.46857C2.6002 7.95353 2.33865 8.49771 2.17957 9.07517C2 9.72701 2 10.433 2 11.845V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M22 14V11.845C22 10.433 22 9.72701 21.8204 9.07517C21.6613 8.49771 21.3998 7.95353 21.0483 7.46857C20.6514 6.92115 20.1001 6.48011 18.9976 5.59805L16.9976 3.99805C15.214 2.57118 14.3222 1.85774 13.3332 1.58413C12.4608 1.34279 11.5392 1.34279 10.6668 1.58413C9.67783 1.85774 8.78603 2.57118 7.00244 3.99805L5.00244 5.59805C3.89986 6.48011 3.34857 6.92115 2.95174 7.46857C2.6002 7.95353 2.33865 8.49771 2.17957 9.07517C2 9.72701 2 10.433 2 11.845V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14Z"
				fill="currentColor"
			/>
			<path
				d="M9 16H15M7.00244 3.99805L5.00244 5.59805C3.89986 6.48011 3.34857 6.92115 2.95174 7.46857C2.6002 7.95353 2.33865 8.49771 2.17957 9.07517C2 9.72701 2 10.433 2 11.845V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V11.845C22 10.433 22 9.72701 21.8204 9.07517C21.6613 8.49771 21.3998 7.95353 21.0483 7.46857C20.6514 6.92115 20.1001 6.48011 18.9976 5.59805L16.9976 3.99805C15.214 2.57118 14.3222 1.85774 13.3332 1.58413C12.4608 1.34279 11.5392 1.34279 10.6668 1.58413C9.67783 1.85774 8.78603 2.57118 7.00244 3.99805Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<g clipPath="url(#clip0_2040_11324)">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M1.25 12.2531C1.25 10.5587 1.25 9.71155 1.46548 8.92934C1.65638 8.23639 1.97024 7.58337 2.39209 7.00142C2.86828 6.34452 3.52983 5.81528 4.85293 4.7568L6.00293 3.8368C8.14324 2.12455 9.21339 1.26843 10.4002 0.940096C11.4471 0.650485 12.5529 0.650485 13.5998 0.940096C14.7866 1.26843 15.8568 2.12455 17.9971 3.83679L19.1471 4.7568C20.4702 5.81528 21.1317 6.34452 21.6079 7.00142C22.0298 7.58337 22.3436 8.23639 22.5345 8.92934C22.75 9.71155 22.75 10.5587 22.75 12.2531V13.1496C22.75 16.5099 22.75 18.1901 22.096 19.4736C21.5208 20.6025 20.6029 21.5204 19.4739 22.0956C18.1905 22.7496 16.5103 22.7496 13.15 22.7496H10.85C7.48969 22.7496 5.80953 22.7496 4.52606 22.0956C3.39708 21.5204 2.4792 20.6025 1.90396 19.4736C1.25 18.1901 1.25 16.5099 1.25 13.1496V12.2531ZM8.75 15.2501C8.33579 15.2501 8 15.5859 8 16.0001C8 16.4143 8.33579 16.7501 8.75 16.7501H15.25C15.6642 16.7501 16 16.4143 16 16.0001C16 15.5859 15.6642 15.2501 15.25 15.2501H8.75Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2040_11324">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M2 11.9999V11.4999V11.4999C2 10.4267 2 9.89012 2.10417 9.38781C2.26984 8.58896 2.62847 7.84279 3.14877 7.21439C3.47594 6.81925 3.89496 6.48404 4.73299 5.81361L7.00244 3.99805C8.78603 2.57118 9.67783 1.85774 10.6668 1.58413C11.5392 1.34279 12.4608 1.34279 13.3332 1.58413C14.3222 1.85774 15.214 2.57118 16.9976 3.99805L18.9976 5.59805C20.1001 6.48011 20.6514 6.92115 21.0483 7.46857C21.3998 7.95353 21.6613 8.49771 21.8204 9.07517C22 9.72701 22 10.433 22 11.845V14C22 16.8003 22 18.2004 21.455 19.27C20.9757 20.2108 20.2108 20.9757 19.27 21.455C18.2004 22 16.8003 22 14 22H7.50006C7.0357 22 6.80353 22 6.60766 21.9846C4.15581 21.7916 2.20841 19.8442 2.01542 17.3923C2 17.1965 2 16.9643 2 16.4999V16.4999V15.9999M9 16H15"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M9 16H15M7.00244 3.99805L5.00244 5.59805C3.89986 6.48011 3.34857 6.92115 2.95174 7.46857C2.6002 7.95353 2.33865 8.49771 2.17957 9.07517C2 9.72701 2 10.433 2 11.845V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V11.845C22 10.433 22 9.72701 21.8204 9.07517C21.6613 8.49771 21.3998 7.95353 21.0483 7.46857C20.6514 6.92115 20.1001 6.48011 18.9976 5.59805L16.9976 3.99805C15.214 2.57118 14.3222 1.85774 13.3332 1.58413C12.4608 1.34279 11.5392 1.34279 10.6668 1.58413C9.67783 1.85774 8.78603 2.57118 7.00244 3.99805Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<g clipPath="url(#clip0_2040_11320)">
				<path
					opacity="0.32"
					fillRule="evenodd"
					clipRule="evenodd"
					d="M1.25 12.2531C1.25 10.5587 1.25 9.71147 1.46548 8.92927C1.65638 8.23631 1.97024 7.58329 2.39209 7.00134C2.86828 6.34444 3.52983 5.8152 4.85293 4.75672L6.00293 3.83672C8.14324 2.12447 9.21339 1.26835 10.4002 0.94002C11.4471 0.650409 12.5529 0.650409 13.5998 0.94002C14.7866 1.26835 15.8568 2.12447 17.9971 3.83672L19.1471 4.75672C20.4702 5.8152 21.1317 6.34444 21.6079 7.00134C22.0298 7.58329 22.3436 8.23631 22.5345 8.92927C22.75 9.71147 22.75 10.5587 22.75 12.2531V13.1495C22.75 16.5098 22.75 18.19 22.096 19.4735C21.5208 20.6024 20.6029 21.5203 19.4739 22.0956C18.1905 22.7495 16.5103 22.7495 13.15 22.7495H10.85C7.48969 22.7495 5.80953 22.7495 4.52606 22.0956C3.39708 21.5203 2.4792 20.6024 1.90396 19.4735C1.25 18.19 1.25 16.5098 1.25 13.1495V12.2531Z"
					fill="currentColor"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M8.25 16C8.25 15.5858 8.58579 15.25 9 15.25H15C15.4142 15.25 15.75 15.5858 15.75 16C15.75 16.4142 15.4142 16.75 15 16.75H9C8.58579 16.75 8.25 16.4142 8.25 16Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2040_11320">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</Fragment>,
	],
]);
